import { useQuery } from "@tanstack/react-query";


export function Presupuesto(tipo) {
   const urlFact = process.env.REACT_APP_URL_DIR + "presupuesto/tipo/" + tipo;
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Presupuesto"],
      queryFn:async () => {
      const response = await  fetch(urlFact, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });
         return response.json();
      }
   });
   // console.log('data: ', data);

   return data;
}

export function PresupuestoId(id) {
   const urlFact = process.env.REACT_APP_URL_DIR + "presupuesto/" + id;
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Presupuesto", id],
      queryFn: () =>
         fetch(urlFact, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });
   //  console.log('PresupuestoId: ', data);

   return data;
}


// export { Presupuesto, PresupuestoId };
